module.exports = __webpack_public_path__ + "media/images/gallery/constellations/puppis/pup_lines-affc898089ccf9376652d9a33646e0f3.gif";